<template>
  <div class="tutorial">
    <button class="skip" @click="changeVisibility()">close</button>
    <div class="info">
      <carousel v-bind="caruselOptions" :per-page="1">
        <slide data-index="0">
          <infoPage1></infoPage1>
        </slide>
        <slide data-index="1">
          <infoPage2></infoPage2>
        </slide>
        <slide data-index="2">
          <infoPage3></infoPage3>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import infoPage1 from "@/components/info-page1";
import infoPage2 from "@/components/info-page2";
import infoPage3 from "@/components/info-page3";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "info-component",
  components: {
    infoPage1,
    infoPage2,
    infoPage3,
    Carousel,
    Slide,
  },
  data: function () {
    return {
      caruselOptions: {
        paginationColor: "rgba(255,255,255,0.45)",
        paginationActiveColor: "#fff",
        paginationPosition: "bottom",
      },
    };
  },
  methods: {
    changeVisibility() {
      this.$emit("changeVisibility");
    },
  },
};
</script>

<style>
.tutorial {
  background-color: #171717;
  z-index: 999;
  padding-top: 100px;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
}
/*SKIP BUTTON*/
.tutorial .skip {
  position: fixed;
  top: 15px;
  right: 9px;
  background: transparent;
  border: transparent;
  color: #fff;
  text-decoration: underline !important;
  font-size: 14px;
}

/*GENERAL*/

.title-step {
  font-family: "Press Start 2P";
  line-height: 22px;
  text-align: center;
  margin-bottom: 31px;
}

.title-step.secundari {
  font-size: 14px;
  color: #d72d20;
}

.description-step {
  font-family: "Press Start 2P";
  padding: 0px 40px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
}

.description-step .instructions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 28px;
}

.instructions p {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  line-height: 18px;
}
</style>
